import React, { ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react'

import { useFormikContext } from 'formik'

const Context = createContext<number>(0)

export const SubmitCountProvider = ({
  children,
  initialValue,
}: {
  initialValue?: number
  children?: ReactNode | ReactNode[]
}) => {
  const [count, setCount] = useState<number>(initialValue || 0)
  const formikContext = useFormikContext()
  const submitCount = formikContext?.submitCount ?? 0

  useEffect(() => {
    setCount((prev) => Math.max(submitCount, prev))
  }, [submitCount])

  const value = useMemo(() => {
    return count
  }, [count])

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useSubmitCount = (): number | undefined => {
  const context = useContext(Context)

  return context
}
